import AmioHttpService from '@/services/amio/amio-http.service'

class FileService extends AmioHttpService {

  async create(file) {
    try {
      const formData = new FormData()
      formData.append('file', file)
      const response = await this.requestPost('/files/upload', formData)
      return response.data
    } catch (err) {
      if (err.message === 'Network Error') {
        throw new Error('Payload Too Large')
      }

      throw this.handleError(err)
    }
  }
}

export default new FileService()
